import { Box, IconButton } from "@mui/material";
import ErrorChip from "./ErrorChip";
import { Close } from "@mui/icons-material";

function Error(props: { error: string; close?: () => void }) {
  const { error, close } = props;

  return (
    <Box sx={{ display: "flex", alignItems: "center", padding: 1, gap: 1 }}>
      <ErrorChip error={error} inLable />
      {close && (
        <IconButton
          onClick={() => {
            close();
          }}
        >
          <Close />
        </IconButton>
      )}
    </Box>
  );
}

export default Error;
